import { forwardRef, type CSSProperties, type ReactNode } from 'react';
import { Icon } from '@/components/foundations';

export type BrowserFrameProps = {
  /** Endereço mostrado na barra (sem `https://`). */
  url: string;
  /** Cor da barra e dos destaques (`--ck`). Sem ela vale o dourado do pacote. */
  accent?: string;
  id?: string;
  /** Rótulo acessível da janela (ex.: "Pré-visualização do checkout"). */
  label?: string;
  children: ReactNode;
};

/** Moldura de navegador (`.browser`) com barra colorida, pontos e URL. */
export const BrowserFrame = forwardRef<HTMLDivElement, BrowserFrameProps>(function BrowserFrame({ url, accent, id, label, children }, ref) {
  return (
    <div className="browser" id={id} ref={ref} role={label ? 'region' : undefined} aria-label={label} style={accent ? ({ '--ck': accent } as CSSProperties) : undefined}>
      <div className="browser-bar"><span className="dots"><i></i><i></i><i></i></span><span className="urlpill"><Icon name="lock" />{url}</span><span className="kebab"><Icon name="kebab" /></span></div>
      {children}
    </div>
  );
});
